// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.custom-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .custom-modal .modal-dialog {
    max-width: 80%;
  }
  
  .custom-modal .modal-body {
    max-height: 300px; /* Set the maximum height you want to allow */
    overflow-y: auto; /* Enable vertical scrolling when the content overflows */
  }
  
  .modal-message {
    white-space: pre-wrap; /* Preserve line breaks in the text */
  }
  `, "",{"version":3,"sources":["webpack://./src/components/css/addNode.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB,EAAE,6CAA6C;IAChE,gBAAgB,EAAE,yDAAyD;EAC7E;;EAEA;IACE,qBAAqB,EAAE,qCAAqC;EAC9D","sourcesContent":["\n.custom-modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .custom-modal .modal-dialog {\n    max-width: 80%;\n  }\n  \n  .custom-modal .modal-body {\n    max-height: 300px; /* Set the maximum height you want to allow */\n    overflow-y: auto; /* Enable vertical scrolling when the content overflows */\n  }\n  \n  .modal-message {\n    white-space: pre-wrap; /* Preserve line breaks in the text */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
